module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_codestates.f6d074665dff410070c26a26071f0f38.png";